<!--
  CollectorPrewarmLine — the one quiet line under the day header (collector-app
  P2-C part B): «بننزّل صور يومك 42 من 180» while the morning download runs,
  «يومك جاهز من غير نت ✓» when every picture the day needs is on the phone.

  No button, no modal, no setting. Anything else (nothing to download for, a
  run that ended short, no worker to cache for) draws NOTHING — the ✓ is the
  signal, and its absence is honest. Never takes space from a screen: it is a
  line of text in the header.
-->
<template>
  <div v-if="text" class="c-prewarm" :class="{ 'c-prewarm--ready': ready }" role="status">
    {{ text }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCollectorPrewarmStore } from '@/stores/collectorPrewarmStore.js';

const { t } = useI18n();
const prewarm = useCollectorPrewarmStore();

const ready = computed(() => prewarm.phase === 'ready');
const text = computed(() => {
  if (prewarm.phase === 'running') return t('collector.prewarm.running', { done: prewarm.done, total: prewarm.total });
  if (prewarm.phase === 'ready') return t('collector.prewarm.ready');
  return '';
});
</script>

<style scoped>
.c-prewarm {
  font-size: 12px;
  color: var(--c-head-sub);
}

.c-prewarm--ready {
  font-weight: 600;
}
</style>
